import { useErpCareerGroupRosterQuery } from 'core/graphql';

export interface ICareerRosterRow {
  studentId: string;
  fullName: string;
  email: string;
  groupName: string;
  /** `null` — человека нет в центре; иначе его текущий статус. */
  memberStatus: string | null;
}

const EMPTY: ICareerRosterRow[] = [];

/**
 * Кого можно добавить в карьерный центр (ТЗ 0039, доводка).
 *
 * Два режима одним запросом: состав группы либо поиск по ФИО во всей базе.
 * Пропускаем запрос, пока не выбрано ни то, ни другое — иначе на открытии
 * диалога уходил бы поход за пустотой.
 *
 * ⚠️ Прежний диалог искал людей через `PaginatedStudents`, чьи роли НЕ
 * включают HR-менеджера и методиста, — а зачислять им разрешено, и поиск
 * молча отдавал пусто. Это поле открыто всем ролям карьерного центра.
 */
export const useCareerGroupRoster = (groupId?: string, search?: string) => {
  const term = (search || '').trim();
  const { data, loading } = useErpCareerGroupRosterQuery({
    variables: { groupId: groupId || undefined, search: term || undefined },
    fetchPolicy: 'cache-and-network',
    skip: !groupId && !term,
  });

  return {
    rows: (data?.careerGroupRoster ?? EMPTY) as ICareerRosterRow[],
    loading,
  };
};
